import axios from 'axios';
import { apiPaths } from 'constants/path';
import { tokenHeader } from 'functions/apiFunctions';
import { AssessmentchangeStatusParam, AxiosResponseType, changeAssessmentApiResponse, VoucherStatusParam } from 'models/Tablet/AssessmentApiTypes';

class AssessmentApi {
    async changeAssessmentStatus(param: AssessmentchangeStatusParam, token: string): Promise<AxiosResponseType<changeAssessmentApiResponse>> {
        const response = await axios.put(`${apiPaths.changeAssessmentStatus}`, param, {
            headers: tokenHeader(token),
        });

        return response.data;
    }

    async chageVoucherStatus(param: VoucherStatusParam, token: string): Promise<AxiosResponseType<changeAssessmentApiResponse>> {
        const response = await axios.post(`${apiPaths.changeVoucherStatus}`, param, {
            headers: tokenHeader(token),
        });

        return response.data;
    }
}

export const TabletAssessmentApi = new AssessmentApi();
